import { proxy } from "valtio";

type StoreType = {
    collapsed: boolean;
    getImages: () => Promise<void>;
    images: ImageType[];
    isActionsClicked: boolean;
    isEdited: boolean;
    actions: Function;
    validationAction: any;
};

export const store = proxy<StoreType>({
    collapsed: false,
    images: [],
    getImages: async function () {
        const response: Response = await fetch(
            `${process.env.REACT_APP_API_V2_URL}/files`
        );
        const result = await response.json();
        const images: ImageType[] = result.data;
        store.images = images;
    },
    isActionsClicked: false,
    isEdited: false,
    actions: () => {},
    validationAction: {},
});

store.getImages();
